import { createRouter } from '@tanstack/react-router'

// Import the generated route tree
import { routeTree } from './routeTree.gen'
import { routerDefaults } from './routerDefaults'

// Create a new router instance
export const router = createRouter({ ...routerDefaults, routeTree })

// Track route changes after router is created
if (typeof window !== 'undefined') {
  router.subscribe('onResolved', () => {
    // Dynamically import to avoid build errors
    import('./analytics/clarityAnalytics').then(({ workerClarity }) => {
      const location = window.location
      workerClarity.trackNavigation(location.pathname + location.search + location.hash)

      workerClarity.trackEvent('route_change', {
        path: location.pathname,
        search: location.search,
        hash: location.hash,
        full_url: location.href
      })

      console.log('Worker Clarity: Route changed to', location.pathname)
    }).catch(err => {
      console.error('Failed to track route change:', err)
    })
  })
}

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}